/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2022
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
//@import BaseMoserObject (loadtime) // superclass

/**
 * Abstract source of data as defined in CDE dashboard spec
 * @author  nbalaba
 */
export default class Source extends BaseMoserObject{

	static ASSET_ID = "asset_id";

	static PORJECT_ID = "project_id";

	static separatator = ":";

	asset_id = null;

	project_id = null;



	/**
	 * @return {String}  the asset_id
	 */
	getAssetId() {
		return this.asset_id;
	}

	/**
	 * @param {String} asset_id the asset_id to set
	 */
	setAssetId(asset_id) {
		this.asset_id = asset_id;
	}

	/**
	 * Abstract method, subclasses must override
	 * @return {boolean}  true if file source, false otherwise
	 */
	isFile() {
		return false;
	}

	/**
	 * Abstract method, subclasses must override
	 * @return {boolean}  true if database source, false otherwise
	 */
	isDatabase() {
		return false;
	}

	getUniqueKey() {
		return this.getProjectId() + ":" + this.getAssetId();
	}

	/**
	 * @return {String}  the project_id
	 */
	getProjectId() {
		return this.project_id;
	}

	/**
	 * @param {String} project_id the project_id to set
	 */
	setProjectId(project_id) {
		this.project_id = project_id;
	}

	toJSON() {
		var json = {};
		json["project_id"] = this.getProjectId();
		json["asset_id"] = this.getAssetId();
		return json;
	}

	toString() {
		var json = this.toJSON();
		try {
			return json.serialize(true);
		} catch (e) {
			throw e;
		}

		return json.toString();
	}
}


// WEBPACK FOOTER //
// ./src/generated/Source.js